// TUT-568 — as faixas do prazo de entrega que os painéis da Visão geral abrem
// na lista do Agendamento (D7 da prévia, opção A). Módulo sem importação: a
// busca da rota (`rotas/buscas.ts`) o lê, e importar a lista dali fecharia um
// ciclo de tipos com a própria rota (a busca tipada vira `any`).
export const FAIXAS_DA_ENTREGA = ["vencidos", "ate-24h", "24-72h"] as const;
export type FaixaDaEntrega = (typeof FAIXAS_DA_ENTREGA)[number];
